import axios from "axios";

export default function EntrylocationemployeeShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/entry_location_employee/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
